import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../config/seo';
import { CONTACT } from '../config/contact';
import { getWhatsAppUrl } from '../utils/orderMessage';
import { PhoneIcon, ClockIcon } from '../components/Icons';

const contactItems = [
  {
    icon: '📍',
    title: 'Adresse',
    value: 'Yaoundé, Cameroun',
  },
  {
    icon: PhoneIcon,
    title: 'Téléphone / WhatsApp',
    value: CONTACT.phoneDisplay,
    href: getWhatsAppUrl('Bonjour DoWhile Food !'),
    external: true,
  },
  {
    icon: '📧',
    title: 'Email',
    value: CONTACT.email,
    href: `mailto:${CONTACT.email}`,
  },
  {
    icon: ClockIcon,
    title: 'Horaires',
    value: 'Lun–Sam : 9h00 – 22h00 · Dim : 11h00 – 20h00',
  },
];

function Contact() {
  return (
    <div className="inner-page contact-page">
      <SEO {...PAGE_SEO.contact} />
      <PageHero
        tag="Restons en contact"
        title="Nous contacter"
        subtitle="On est là pour vous — n'hésitez pas à nous écrire"
      />

      <section className="page-content page-content-cream">
        <div className="contact-grid">
          <div className="contact-info">
            <h2 className="inner-section-title">Nos coordonnées</h2>
            <p className="contact-intro">
              Commandez par téléphone, WhatsApp ou passez nous voir à Yaoundé.
            </p>

            {contactItems.map(({ icon: Icon, title, value, href, external }) => (
              <div key={title} className="contact-item">
                <div className="contact-icon-wrap">
                  {typeof Icon === 'string' ? (
                    <span className="contact-emoji">{Icon}</span>
                  ) : (
                    <Icon size={20} />
                  )}
                </div>
                <div>
                  <h4 className="contact-label">{title}</h4>
                  {href ? (
                    <a
                      href={href}
                      className="contact-value contact-link"
                      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    >
                      {value}
                    </a>
                  ) : (
                    <p className="contact-value">{value}</p>
                  )}
                </div>
              </div>
            ))}

            <Link to="/menu" className="btn btn-primary contact-cta">
              <PhoneIcon size={16} />
              Commander maintenant
            </Link>
          </div>

          <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
            <h3 className="form-title">Envoyer un message</h3>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label" htmlFor="prenom">Prénom</label>
                <input id="prenom" type="text" className="form-input" />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="nom">Nom</label>
                <input id="nom" type="text" className="form-input" />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="email">Email</label>
              <input id="email" type="email" className="form-input" />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="telephone">Téléphone</label>
              <input id="telephone" type="tel" className="form-input" />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="sujet">Sujet</label>
              <input id="sujet" type="text" className="form-input" />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="message">Message</label>
              <textarea id="message" className="form-textarea" rows="4" />
            </div>
            <button type="submit" className="btn btn-primary btn-full">Envoyer le message</button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default Contact;
